import { Controller } from '@hotwired/stimulus';

// Bridges a quote card to its map pin: hover highlights/bounces the pin,
// a plain click flies the map to it. Matches the pin by quote id (the
// quotes-map markers are keyed by quote id).
const MODAL_SELECTOR = '[data-local-modal-manager-target="modal"]';

export default class extends Controller {
  static values = { quoteId: String };

  enter() {
    if (this._modalOpen()) return;

    this._emit('quotesMap:hoverValuerEnter');
  }

  leave() {
    this._emit('quotesMap:hoverValuerLeave');
  }

  focus(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
      return;

    // The card's Instruct modal lives inside this element, so opening it or
    // interacting with it must neither fly to nor keep the pin bouncing.
    if (
      event.target.closest('[data-action*="local-modal-manager#open"]') ||
      event.target.closest(MODAL_SELECTOR)
    ) {
      this._emit('quotesMap:hoverValuerLeave');
      return;
    }

    if (event.target.closest("button, a, input, select, textarea, [role='button']")) return;

    this._emit('quotesMap:focusValuer');
  }

  _modalOpen() {
    return Boolean(this.element.querySelector(`${MODAL_SELECTOR}:not(.hidden)`));
  }

  _emit(name) {
    if (!this.quoteIdValue) return;

    window.dispatchEvent(new CustomEvent(name, { detail: { id: this.quoteIdValue } }));
  }
}
